module.exports = __webpack_public_path__ + "static/img/item.df86ba9.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/activity4/item.png
// module id = pABY
// module chunks = 7